import React, {useEffect} from 'react';
import {useParams, useNavigate} from "react-router-dom";
import style from './EmployeeProfile.module.scss'; // импорт стилей
import ReactMarkdown from 'react-markdown';


export default function EmployeeProfile({teamsData}) {
    const navigate = useNavigate();
    const {nameEmplo} = useParams();
    const selectedEmployee = teamsData.find(employee => `${employee.attributes.firstName}-${employee.attributes.lastName}` === nameEmplo);
    const handleGoBack = () => {
        navigate(-1);
    };
    const url = "https://sqn-law.ru:3001"
    const imgUrl = `${url}${selectedEmployee.attributes.userAvatar.data.attributes.url}`;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={style.employeeProfile}>
            <div className={style.innerContainer}>
                <div className={style.image}>
                    <img src={imgUrl} alt='PhotoEmployee'/>
                </div>
                <div className={style.text}>
                    <div className={style.textContainer}>
                        <h2 className={style.name}>{`${selectedEmployee.attributes.firstName} ${selectedEmployee.attributes.lastName}`}</h2>
                        <div className={style.contact}>
                            <div className={style.phone_email}>
                                <span>Email</span>
                                <a href={`mailto:${selectedEmployee.attributes.email}`}>{selectedEmployee.attributes.email}</a>
                            </div>
                        </div>
                        <ReactMarkdown className={style.markdown}>
                            {selectedEmployee.attributes.description}
                        </ReactMarkdown>
                        <div onClick={handleGoBack} className={style.close}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80"
                                 fill="none">
                                <rect width="80" height="80" rx="40" fill="#FF8686" fillOpacity="0.1"/>
                                <path d="M29 51.6274L51.6274 29" stroke="#D11018" strokeWidth="1.6"
                                      strokeLinecap="round"/>
                                <path d="M29.0005 29L51.6279 51.6274" stroke="#D11018" strokeWidth="1.6"
                                      strokeLinecap="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
